import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/htx/current-cardiological-state/cpet";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	cPet: {
		id: "form.c_pet",
		defaultMessage: "Szív PET vizsgálat"
	},
	description: {
		id: "form.c_pet.description",
		defaultMessage: "Szöveges összefoglaló"
	}
});

const fields: { [key: string]: FieldData } = {
	description: {
		type: "field",
		path: ["description"],
		label: messages.description,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.description }] }]
};

export const node: LeafNode = {
	id: "cPet",
	value: {
		schemaId: "cpet",
		title: messages.cPet,
		validator,
		fieldset
	}
};
